var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNsccClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 750,
    height: 750,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(903)",
    d: "m0 0h1145v1124h-2v6l-3 1-1-10-1 1-2 24-2 47-1 13h-1l-1-19-5 29-1 13-2 7-1 12-2-3-1-2-3 21-2 17-3 8-1-4-1-1-3 22-2 3-4 9-5 18-6 16-4 16-1 9-2 1v-3h-3l-3 21-1 2v5l-2 1-1-5h-2v5l-3 9-1 13h-2v-2l-4 1-2 8-1 9-1 4v2l-5-2-1 3-1 7-1 1-1 7-3 3-1 2-1-4h-2v7l-1 3-2 7-1 5-2-1v-2h-2l1 5h-2l-3 8v6l-3 1 1 4-5-2-1 6-3 12-5-1-2 6-1 7-1 3-2 3-4-3-1 4-2 7v4h-5v3l-2-1-1 7-1 3-1 5-3 1-5-1v5l-1 1-1 7h-2l-1 3h-2l-1 3h-3l1 4h-2l1 6-4 1-2-1v2l-3 2-1 5h-3l2 5-6-1-1 8-2 1-1 7-4-2v2l-3 3-2 7-2 1-1 4-3-2v3h-2v6h-2v2h-2l-1 2h-3l1 3-4 2 1 5-2 3-7 2-1 5-5 5h-3l-1 4-5 6-12 12-7 8-10 11-2 4h-2v3h-3l-1 3-7 6-4 5h-2l-2 7-10 10-5 1-15 14-10 9-12 11-6 4h-2l1 3-4 4-5 2-2 2v3l-4 3h-7l1 5-2 4-7-1v4l-5 1v2l3 2h-4-2l-1 3h-4l-2 2h-3v3l-1 3-4-1v2l-3 1h-2-3l2 5h-2v3l-3 1-2-1-3 2-1 2-3-1 1 3-2 1 2 1-1 2-4-2 1 3h-4l-7 1-1 3-1 4-1 1h-6l-6 3-2-1 2 2 3 1-3 4-5-1v2l-9 1-2 1 2 2-2 2-1 3-7 1-3 2-5-2 3 5h-3l2 4h-2l-3-3 1 3h-9v2l-5-1-1 4h3l-1 3-4 1-1-1v2l-5-1v2h-5l-2 1-2-1 3 3v2h-2l1 3h-6l-2 1-2-1-1 3v-2h-3l-1 2h-3l2 2-3 1v2l-7 3-4-1-1 2-6-1v4 1l-1 3-11 2h-7l-5 2 3 2v2l-5 2-6-1v2l-13 1v2l4 1v4l-3-1h2v-2l-5 4-11 1-7 2v3l-6 3-3 1-16 3 2 2-2 1 2 2-18 2-11 3 6 2-2 2-11 2-17 3h-3l4 2-8 4-19 4-6 2-4 2-3 1 2 1-1 1h-10l-15 3 6 1v1l-24 4-21 3 6 1v2l-19 2-26 4-6 1v1l-23 4-24 2-44 2 4 2 4-1 1 2-7 3 4 2h-193v-1h7v-2h-10v-3l-7-1-19-1-10-3-33-4-26-4-3-2-4-2-41-9h-8l-4-2 1-1h-7l-5-1v-2l-46-14-30-11-13-5-33-11-27-12-16-8-46-22-18-10-12-6-16-7-11-6-1-5-7-1-2-1-1 2-5-2-1-4v-3l-4-1-7-4-5-4h-3v-3l-6 1-3-3 1-2h-2v-3l-6-1v-2l-5-1-3-6h-3v-2h-6l1-3h-2l-1-2-3-1h2v-2l-5 1-1-3h-4v-2l-3 1-1-5-1-3-4 1-5-2-1-5-2-3-5 1v-2l-5-5 1-2h-2v-2h-8v-2l-4 1v-2l-3-1 1-3h2l-4-1v-2l-3 1-2-3-1 2-3-5h2v-2l-3-1v-2l-4 2-4-4-1-5 1-3-4 2-6-3-1-5 1-1-8-1-3-4v-2h2v-3l-3 1v-3l-5 1-4-3 1-3-1-4-5 1-1-2-2-1-2-3v-4l-8-2-1-5v-2l-5-2v2l-2-1-3-5 2-3h-2v-3l-5 2-3-3-1-9h-2v2h-2l-1-2h-3l-2-6 1-1-3-3-2 1-1-2h-3l-1-3 1-2h-2l-1-2-2-1 1-2h-2v2l-4-2v-4l-2-1v-3l-4 1v-3h4l-1-1-6 1-2-5 2-1-1-3h-2v-6h-4v-2l-4-1-1-3v-3l-1-2h-3-3l-2-7-1-3h-5l-4-7v-2-3h-3v-2l-4 1-1-4 1-1-3-4 1-4-2-1 1-2-5 1v-2l-3-1-2-7-3-3h-4l-2-5h2v-3l-3 1-1-7-5-1-4-12-2-2h-3l-1-2h2v-2l-3 1-1-6-1-2 1-2-2-1 1-2h-3v-3l-4 1-1-5v-3h-2l-2-6-6-8-2-8-3 1-3-5v-2l-3-7v-4h-3l-7-15-8-16-8-15-5-13-4-6-5-13-4-8-9-22-6-18-5-11-20-60-8-29-5-23-5-17-6-33-3-14-3-27-4-41-2-3-2 7h-2l-1-5v-208l2-1h6l2-31 1-25 2-17 3-5 4-19 5-25 4-15 3-19 6-19 4-15 9-32 4-5 7-23 3-3 5-21 3-5 2-1 3-13 1-8 2-1v2l3-1 3-10 3-12 2 2 2-2h1l3-14 3-6 2 2 3-9 3-13 4 2 6-22h2v4h2l1-6 2-5 2-10 5 2 3-12h2l-1-7h2l1 2 4-3 3-12h2l-1-3 4 2 3-9 2-8h2l1 2 2-2 2-3 2-13 2-2 2 1 1 3 1-3h2v-6l4-8 4 1 4-10 4-2 1-2h2l3-12 4-3 1 2 3-7v-2h2l1-3 5-1 1-4h2v-6l3 1 1-3h2l2-5 1-7 2-3 5 1 3-11 4-1 2 2 2-3v-7h3l1-3 4 2 3-9 4-3 2 1 5-8 5-4 8-10 40-40 8-7 19-19 4-2 1-5 3-2h5l3-8 6-1h3v-7h2l1-2 5-1 2 1v-3h2v-2h-2v-2h2v-2l7-2 1 1 1-2 4 1v-3l2-2 5-4 3 1v-2l3-1 1-4 1-2 7-2h1l1-2 2-2 1 1 1-2-2-1 4-1 1-2h2l2-2 4-1 1-3h3l-1-3 6-2h4v-5l4-4h5l2-3 2 1v-3l4 1v-2h-2v-2l5 1v-2l8-2h2l1-7 13-3h4l-2-6h3v2h2l-1-3 6-1 3-1-1-4 1-3 9-3h2l2-1h3l-3-5 5-1 4-1 8-1-1-4 3 2v-2l-2-4h3l1 2 1-2 11-1 2-5 1-4 7-1 2 1v-3h2v2l6-1-2-7 5-1 10-1 6 1v-5l-1-2h2v-2l4-1 13-1 2-1 2 1v-2h2l-3-3v-2l6-1h8l1-2h9v-2l3-1-5-1-2-2 14-3 15-1-1-4-1-2 21-3 9-1 3-2-5-3v-1l31-4h4l-3-3-4-3 29-3 10-2-5-1v-2l16-3 25-3-2-2 1-4 40-2 12-2-4-2-3-2 15-2 49-2 6-1-1-5zm-364 123m1483 1116m-38 133 1 2zm-11 25m-7 22v2l2-1zm-43 86m-1 4m-1792 20m1763 29m-1724 34m8 14m1646 57m-1587 20m1502 73m-1419 10m30 29m11 9m28 23m1263 1m1 1m-1226 27m1187 2m-1172 12 2 2v-2zm28 18v2l2-1z",
    fill: "#50D6CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,144)",
    d: "m0 0 2 1-1 1v13l1 21v1718l-1 6-4 1-9-3-7-4-1-5-7-1-2-1-1 2-5-2-1-4v-3l-4-1-7-4-5-4h-3v-3l-6 1-3-3 1-2h-2v-3l-6-1v-2l-5-1-3-6h-3v-2h-6l1-3h-2l-1-2-3-1h2v-2l-5 1-1-3h-4v-2l-3 1-1-5-1-3-4 1-5-2-1-5-2-3-5 1v-2l-5-5 1-2h-2v-2h-8v-2l-4 1v-2l-3-1 1-3h2l-4-1v-2l-3 1-2-3-1 2-3-5h2v-2l-3-1v-2l-4 2-4-4-1-5 1-3-4 2-6-3-1-5 1-1-8-1-3-4v-2h2v-3l-3 1v-3l-5 1-4-3 1-3-1-4-5 1-1-2-2-1-2-3v-4l-8-2-1-5v-2l-5-2v2l-2-1-3-5 2-3h-2v-3l-5 2-3-3-1-9h-2v2h-2l-1-2h-3l-2-6 1-1-3-3-2 1-1-2h-3l-1-3 1-2h-2l-1-2-2-1 1-2h-2v2l-4-2v-4l-2-1v-3l-4 1v-3h4l-1-1-6 1-2-5 2-1-1-3h-2v-6h-4v-2l-4-1-1-3v-3l-1-2h-3-3l-2-7-1-3h-5l-4-7v-2-3h-3v-2l-4 1-1-4 1-1-3-4 1-4-2-1 1-2-5 1v-2l-3-1-2-7-3-3h-4l-2-5h2v-3l-3 1-1-7-5-1-4-12-2-2h-3l-1-2h2v-2l-3 1-1-6-1-2 1-2-2-1 1-2h-3v-3l-4 1-1-5v-3h-2l-2-6-6-8-2-8-3 1-3-5v-2l-3-7v-4h-3l-7-15-8-16-8-15-5-13-4-6-5-13-4-8-9-22-6-18-5-11-20-60-8-29-5-23-5-17-6-33-3-14-3-27-4-41-2-3-2 7h-2l-1-5v-208l2-1h6l2-31 1-25 2-17 3-5 4-19 5-25 4-15 3-19 6-19 4-15 9-32 4-5 7-23 3-3 5-21 3-5 2-1 3-13 1-8 2-1v2l3-1 3-10 3-12 2 2 2-2h1l3-14 3-6 2 2 3-9 3-13 4 2 6-22h2v4h2l1-6 2-5 2-10 5 2 3-12h2l-1-7h2l1 2 4-3 3-12h2l-1-3 4 2 3-9 2-8h2l1 2 2-2 2-3 2-13 2-2 2 1 1 3 1-3h2v-6l4-8 4 1 4-10 4-2 1-2h2l3-12 4-3 1 2 3-7v-2h2l1-3 5-1 1-4h2v-6l3 1 1-3h2l2-5 1-7 2-3 5 1 3-11 4-1 2 2 2-3v-7h3l1-3 4 2 3-9 4-3 2 1 5-8 5-4 8-10 40-40 8-7 19-19 4-2 1-5 3-2h5l3-8 6-1h3v-7h2l1-2 5-1 2 1v-3h2v-2h-2v-2h2v-2l7-2 1 1 1-2 4 1v-3l2-2 5-4 3 1v-2l3-1 1-4 1-2 7-2h1l1-2 2-2 1 1 1-2-2-1 4-1 1-2h2l2-2 4-1 1-3h3l-1-3 6-2h4v-5l4-4h5l2-3 2 1v-3l4 1v-2h-2v-2l5 1v-2l8-2h2l1-7 13-3h4l-2-6h3v2h2l-1-3 6-1zm-373 1385m39 63m8 14m59 77m83 83m30 29m11 9m28 23m38 29m15 14 2 2v-2zm28 18v2l2-1z",
    fill: "#73A0E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028)",
    d: "m0 0h496l1 3-1 628v200l1 22 1 48v32l-1 18-3 9-5 4-7-1-5-6v-2l-4-2-6-10-8-16-10-19-18-34-27-57-9-16-8-16-13-23-11-24-8-16-9-19-9-21-8-16-14-25-9-17-9-16-16-32-10-19-10-23-14-28-8-14-10-20-9-16-13-29-8-16-9-17-8-19-7-15-13-25-8-15-12-22-10-20-12-22-10-22-7-16-9-17-10-18-8-16-10-17-6-10-8-20-8-16-8-15-11-23-16-32-5-11-4-12-1-10z",
    fill: "#6CADE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,1084)",
    d: "m0 0 7 1v2l5 1v2l4 1 12 22 14 28 9 19 10 19 14 26 10 19 10 22 18 36 10 19 8 17 8 16 10 19 6 11 8 17 40 80 12 27 8 13 5 9 8 14 6 12 13 28 12 25 47 94 8 17 10 19 13 25 8 14 11 21 7 15 18 36 9 19 7 14 5 9 3 7 7 15 5 14 3 6 3 9 4 6 1 7-5 4h-2l1 5 4 1v2l-5 2-6-1v2l-13 1v2l4 1v4l-3-1h2v-2l-5 4-11 1-7 2v3l-6 3-3 1-16 3 2 2-2 1 2 2-18 2-11 3 6 2-2 2-11 2-17 3h-3l4 2-8 4-19 4-6 2-4 2-3 1 2 1-1 1h-10l-15 3 6 1v1l-24 4-21 3 6 1v2l-19 2-26 4-6 1v1l-23 4-24 2-44 2 4 2 4-1 1 2-7 3 4 2h-85l-1-72v-371l1-362v-133l1-21z",
    fill: "#6CADE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028)",
    d: "m0 0h3l4 18 6 13 8 15 8 17 8 18 18 36 10 25 11 18 1 3h2l3 8 9 16 12 20 6 13 6 16 7 15 5 9 8 11 6 12 7 15 5 10 13 23 15 30 14 34 6 12 5 8 11 23 2 5 2 7 8 14 6 11 12 24 6 11 5 9 6 12 5 13 9 21 8 14 5 7 13 26 6 11 8 13 7 11 4 8 4 6 11 23 9 21 7 14 10 19 3 4 3 9 1 5 4 10 5 7 3 6 13 23 8 13 12 23 6 18 6 15 6 10 4 6 5 9 8 15 4 9 6 10 2 2 11 1 9-1 3-3 3-10 1-14 2-4v32l-1 18-3 9-5 4-7-1-5-6v-2l-4-2-6-10-8-16-10-19-18-34-27-57-9-16-8-16-13-23-11-24-8-16-9-19-9-21-8-16-14-25-9-17-9-16-16-32-10-19-10-23-14-28-8-14-10-20-9-16-13-29-8-16-9-17-8-19-7-15-13-25-8-15-12-22-10-20-12-22-10-22-7-16-9-17-10-18-8-16-10-17-6-10-8-20-8-16-8-15-11-23-16-32-5-11-4-12-1-10z",
    fill: "#61B7DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1336,1665)",
    d: "m0 0 4 5 12 25 10 21 7 12 8 16 8 14 11 21 7 15 18 36 9 19 7 14 5 9 3 7 7 15 5 14 3 6 3 9 4 6 1 7-5 4h-2l1 5h-2l-3 3-1-2 1-3-4-1-3-6v-3h-2l-4-6-2-7-3-21-3-9-5-13-7-15-6-16-4-9-6-14-10-24-3-10-8-16-13-11-2-3-6-3-3-10-3-4-2-11-3-9-5-21-7-19-7-14z",
    fill: "#60B7DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,1084)",
    d: "m0 0 7 1v2l5 1v2l4 1 12 22 14 28 9 19 10 19 14 26 10 19 10 22 25 50-1 2-20-38-3-4v-2h-2l-4-8-6-5-4-7-3-5-7-6-5-10-5-5-2-9-4-6-6-22-4-7-5-9v-2h-2v-2l-3-1-3-3-2-1v-4l-6-1-3-3-12-1-1-1v-5l-5-1-2-6-2-1v60h-1v-73l1-21z",
    fill: "#61B7DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1152,1298)",
    d: "m0 0 3 3 8 17 8 16 10 19 6 11 8 17 40 80 12 27 8 13 5 9 8 14 6 12 13 28 12 25 3 6-1 2-11-20-6-12-4-6-9-11-9-14-5-6-5-10-9-20-5-13-3-9-6-10-9-10-6-4-5-8-2-7h-2l-4-11-2-13-3-8-2-10-8-25-11-22-12-25-11-22z",
    fill: "#61B7DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,144)",
    d: "m0 0 2 1-1 1v13l1 21v212h-1l-1-125-2-43-1-28-1-8-2-9-2-2-1-7-1-5-1-6h-6l-4 3-6-2 2-4 12-3h4l-2-6h3v2h2l-1-3 6-1z",
    fill: "#73B2E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,1515)",
    d: "m0 0h1v383l-1 6-4 1-9-3-7-4v-2h2v2l6-1 1-5 2-2 3-9 4-38 1-47v-38z",
    fill: "#6DADE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1523)",
    d: "m0 0 2 3-1 628v48l-2 4-1-83 1-16v-525l-1-25v-27h2z",
    fill: "#61B7DE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,893)",
    d: "m0 0h1v17l-2 37-5 7-4 1v-30l2-1h6z",
    fill: "#6BAEE3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,1843)",
    d: "m0 0h1l-1 50-3 9h-3v2l-6-2-7-4v-2h2v2l6-1 1-5 2-2 3-9 4-37z",
    fill: "#6CACE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(4,1100)",
    d: "m0 0h1l3 22v11l-3-2-2 7h-2l-1-5v-24h3z",
    fill: "#7CBCE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,770)",
    d: "m0 0h1l1 61 1 22v27h-1l-1-23-2-17v-49z",
    fill: "#61B7DE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,1841)",
    d: "m0 0h1v57l-1 6-4 1-3-3h3l1-8 1-1 1-37z",
    fill: "#61B7DE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(17,842)",
    d: "m0 0 2 2-1 11-3 9-2 10h-2l1-17 2-8z",
    fill: "#81C1E4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,2041)",
    d: "m0 0h7l2 1 4-1 1 2-7 3 4 2h-15l2-5h2z",
    fill: "#FDFDFD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,163)",
    d: "m0 0h2l-2 4-5 4h-3v3h-5v-5l4 1v-2h-2v-2l5 1v-2z",
    fill: "#80C6E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,704)",
    d: "m0 0 1 2-2 9-4 11-1 5-2-1 2-10 4-15z",
    fill: "#71B5E3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,924)",
    d: "m0 0h6l-1 6-7 1v-6z",
    fill: "#7AE0D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(80,622)",
    d: "m0 0 1 2 4-1v3h-2l-1 8-4 1 1-12z",
    fill: "#6BAFE2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(362,1807)",
    d: "m0 0 5 1 1 1v6h-2v-2l-4 1v-2l-3-1 1-3h2z",
    fill: "#87BBE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,1799)",
    d: "m0 0h3v3l8 1v4h-4v-2l-3 1-2-3-1 2-3-5z",
    fill: "#6EB0E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,1407)",
    d: "m0 0h2l7 14-1 4-1-4h-2l-5-12z",
    fill: "#68B2E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,1676)",
    d: "m0 0h3v2h3v3h3v4l-6 1-2-5 2-1-1-3z",
    fill: "#87C2E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,171)",
    d: "m0 0 3 3-2 1v2l-6 3-2-1 1-5h5z",
    fill: "#6AB8DF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,203)",
    d: "m0 0 2 1-2 4-5 1-1 4-4-1 3-1 1-4 1-2z",
    fill: "#71B6E2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1239,2015)",
    d: "m0 0 12 3v1h-12l-5 1v-2z",
    fill: "#73A0E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(128,524)",
    d: "m0 0 6 2v3h-3l-1 3h-2l-1 2v-7z",
    fill: "#79BCE3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,251)",
    d: "m0 0 5 1-8 8-2-1 2-3v-3z",
    fill: "#96CAE9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,31)",
    d: "m0 0 9 1 1 2-3 1-11-1v-2z",
    fill: "#FDFDFD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,2027)",
    d: "m0 0h15v3l-12-1z",
    fill: "#72A1E8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,232)",
    d: "m0 0 5 1-8 6h-2v-4h2l1-2z",
    fill: "#71B9E1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1239,2018)",
    d: "m0 0h7l3 2-11 1v2h-2l2-4z",
    fill: "#66B7DE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,1690)",
    d: "m0 0h5l1 4 1 2h-2v2l-4-2z",
    fill: "#6DAAE4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,1276)",
    d: "m0 0 2 1 2 6v10l-2-4z",
    fill: "#7AC0E2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,223)",
    d: "m0 0 4 1-1 3-2 1h-6v-2h2v-2z",
    fill: "#E5F7F6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1098,2040)",
    d: "m0 0 5 1v2l-3 3-1 2h-2v-7z",
    fill: "#50D7CE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(199,417)",
    d: "m0 0 2 4-4 6h-2l1-7z",
    fill: "#7FC5E2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,716)",
    d: "m0 0 1 3-3 7-1 5-2-1 2-10 1-2h2z",
    fill: "#8EC7E7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,601)",
    d: "m0 0 2 2 2-2h2l-1 4h-2v2l-3 1-1-4z",
    fill: "#8AC4E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319 2e3)",
    d: "m0 0 4 1-2 1h-8v-1z",
    fill: "#FDFDFD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,1545)",
    d: "m0 0h2l2 5h-2z",
    fill: "#5DC2D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(107,1487)",
    d: "m0 0 2 2 1 5-2-1z",
    fill: "#DDE9F8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,1986)",
    d: "m0 0 5 1-4 1z",
    fill: "#68DCD4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(78,1428)",
    d: "m0 0 2 1-1 4z",
    fill: "#FDFDFD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,1849)",
    d: "m0 0 2 1v2l-3-1z",
    fill: "#68B4E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2006,1314)",
    d: "m0 0h1v6h-1z",
    fill: "#50D7CE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,2025)",
    d: "m0 0h5v1h-5z",
    fill: "#50D7CE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1423,1967)",
    d: "m0 0h2v2l-3-1z",
    fill: "#FDFDFD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1899)",
    d: "m0 0 3 1-1 2z",
    fill: "#57CCD3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,2026)",
    d: "m0 0 4 1z",
    fill: "#50D7CE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2007,1310)",
    d: "m0 0 1 4z",
    fill: "#50D7CE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,2023)",
    d: "m0 0 3 1z",
    fill: "#50D7CE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,2022)",
    d: "m0 0 3 1z",
    fill: "#50D7CE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,2013)",
    d: "m0 0 3 1z",
    fill: "#50D7CE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(735,2006)",
    d: "m0 0 3 1z",
    fill: "#50D7CE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731 2e3)",
    d: "m0 0 3 1z",
    fill: "#50D7CE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(684,1989)",
    d: "m0 0 3 1z",
    fill: "#73A0E9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1400,1976)",
    d: "m0 0 3 1z",
    fill: "#89E3DD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,1868)",
    d: "m0 0 2 2h-2z",
    fill: "#59C9D5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1735,1760)",
    d: "m0 0 2 1-2 1z",
    fill: "#50D7CE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,1743)",
    d: "m0 0 1 2-2-1z",
    fill: "#89E3DD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1754,1741)",
    d: "m0 0 1 2-2-1z",
    fill: "#89E3DD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1831,1655)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,1596)",
    d: "m0 0 2 2h-2z",
    fill: "#59C9D5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,1508)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,2024)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,2009)",
    d: "m0 0 2 1z",
    fill: "#70A6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,2008)",
    d: "m0 0 2 1z",
    fill: "#73A0E9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,2007)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,2007)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1325 2e3)",
    d: "m0 0 2 1z",
    fill: "#FDFDFD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728 2e3)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725 2e3)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701 2e3)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(698,1994)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,1992)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,1988)",
    d: "m0 0 2 1z",
    fill: "#5EC2D9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,1985)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,1984)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,1968)",
    d: "m0 0",
    fill: "#B8CEF3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1489,1937)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,1817)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1899,1558)",
    d: "m0 0 2 1z",
    fill: "#50D7CE"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,1506)",
    d: "m0 0",
    fill: "#6DADE4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1937,1489)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,1485)",
    d: "m0 0",
    fill: "#5EC2D9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 1324)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(392,216)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,2016)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,2010)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704 2e3)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,1993)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,1970)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,1968)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,1938)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,1929)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1880)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,1878)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,1873)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,1863)",
    d: "m0 0",
    fill: "#73A0E9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1618,1859)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1646,1840)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,1830)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,1821)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(369,1818)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1737,1759)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,1747)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1750,1745)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,1740)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1772,1721)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,1673)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,1660)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1877,1589)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1880,1588)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1879,1587)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,1527)",
    d: "m0 0",
    fill: "#6DADE4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(118,1512)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(80,1433)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(185,433)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,395)",
    d: "m0 0",
    fill: "#6DADE4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,394)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(215,392)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,391)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,390)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,290)",
    d: "m0 0",
    fill: "#6DADE4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(394,214)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,194)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,152)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,100)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,99)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,98)",
    d: "m0 0",
    fill: "#50D7CE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,79)",
    d: "m0 0",
    fill: "#FDFDFD"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,77)",
    d: "m0 0",
    fill: "#6DADE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsccClub);
export default __webpack_public_path__ + "static/media/nscc-club.eaba5e964e8b8caaaa8b521a1cc7469d.svg";
export { ForwardRef as ReactComponent };